export default "__VITE_ASSET__COCvt6z3__"